import React, { useEffect, useState, useMemo } from "react";
import jsPDF from "jspdf";
// import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import {
  DATA_EXPORT,
  DELETE_MESSAGE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";
import CleanupConfirmationModal from "../../../../components/Modal/CleanupConfirmation";
import SkipbarcodeConfirmationModal from "../../../../components/Modal/barcodesheetmodal";
import { checkUserPermission } from "../../../../common/UserPermission";
import Select from "react-select";
import * as XLSX from "xlsx";
import { Noimage } from "../../../../common/imagePath";
import moment from "moment";
//MUI Table
import { MaterialReactTable } from "material-react-table";
import { Box, Button, MenuItem } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import ChangePassword from "../../../../components/Modal/ChangePassword";
// import { MenuItem } from "@mui/material";
// import { Box, Button } from "@mui/material";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { toastSuccess } from '../../../../common/Toast';
// import { DELETE_MESSAGE } from '../../../../common/Constant';

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-customers";
let PERMISSION_EDIT = "/manage-customers/:id";
let PERMISSION_DELETE = "delete-customers";
let PERMISSION_MANAGE_DELETED_CUSTOMERS = "/deleted-customers";
let PERMISSION_EXCEL_IMPORT = "/import-excel-customers";
let PERMISSION_EXCEL_EXPORT = "excel-export-customers";
let PERMISSION_CLEANUP_OLD_CUSTOMERS = "cleanup-old-customers";
let PERMISSION_CUSTOM_FIELD_CONFIGURATION = "/custom-field-configuration";
let PERMISSION_CUSTOMER_INTAKE_FORM = "/customer-intake-form";

let PERMISSION_EMAIL_CUSTOMERS = "email-customers";
let PERMISSION_MAILING_LABELS = "mailing-labels-customers";
let PERMISSION_BARCODE_LABELS = "barcode-labels-customers";
let PERMISSION_BARCODE_SHEETS = "barcode-sheets-customers";

const Customers = () => {
  let selectData = [];
  const navigate = useNavigate();
  let pathforpdf = "";
  let selectDatas = [];
  // let excelalldata;
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(6);
  const [state, setState] = useState("");

  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedCustomerCheckboxs, setselectedCustomerCheckbox] = useState("");
  const [selectedCustomerCheckEmails, setselectedCustomerCheckEmails] =
    useState("");
  const [selectedCustomerCheckpathforpdf, setselectedCustomerCheckpathforpdf] =
    useState("");
  const [selectedCustomerBarcodeLabel, setselectedCustomerBarcodeLabel] =
    useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");

  const [PasswordModalOpen, setPasswordModalOpen] = useState(false);
  const [customerId, setCustomerId] = useState(0);

  const options = [
    { label: "All", value: 1 },
    { label: "Today", value: 7 },
    { label: "Last Day", value: 8 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [showDateFilterModal, setShowDateFilterModal] = useState(false);
  const [showaction, setShowAction] = useState(true);

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
  };

  const handleDateFilterConfirm = () => {
    console.log("api call delete");
    const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
    console.log("deleteRequestParam: 12", deleteRequestParam);
    const deleteApiUrl = `${config.customersBaseUrl}/customers/delete`;
    // console.log("deleteApiUrl: ", deleteApiUrl);
    axios
      .post(`${deleteApiUrl}`, deleteRequestParam, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then(() => {
        toastSuccess(SUCCESS_MESSAGE);
        window.location.reload();
        window.location.href = window.location.href;
      });

    setShowDateFilterModal(false);
  };

  //table state
  // const [columnFilters, setColumnFilters] = useState([]);
  // const [globalFilter, setGlobalFilter] = useState('');
  // const [sorting, setSorting] = useState([]);
  // const [pagination, setPagination] = useState({
  //   pageIndex: 0,
  //   pageSize: 25,
  // });

  // const navigate = useNavigate()

  const deleteRequestParam = localStorage.getItem("DeleteRequestParam");

  // Styles
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      color: "#000",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      color: state.isActive ? "#000" : "#000",
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        color: "#000",
        backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
      },
    }),
  };

  //BARCODE
  const handlebarcodesheet = (pID) => {
    const barcodeRequestParam = pID;
    //   Barcode_Id: pID,
    // };
    localStorage.setItem(
      "BarcodeRequestParam",
      barcodeRequestParam
      // JSON.stringify(barcodeRequestParam)
    );

    getCustomerDetailsForLabelById(barcodeRequestParam);
  };

  const getCustomerDetailsForLabelById = (barcodeRequestParam) => {
    axios
      .get(
        `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${barcodeRequestParam}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // setFormValues(res.data.ResponseData);
        console.log(res.data);
        console.log(res.data.ResponseData);
      });
  };

  // Get all tag data
  const handleListData = (
    startingdate,
    endingdate,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    axios
      .get(
        `${
          config.customersBaseUrl
        }/customers?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&startdate=${startingdate == undefined ? "" : startingdate}&enddate=${
          endingdate == undefined ? "" : endingdate
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setRowCount(res.data.ResponseData[0].TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  // pdf make onclick

  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     // for get detlais form id
  //     setSelectedRows(e.selectedRows.map((x) => x.Id));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Id);
  //     const selectedCustomerCheckboxIDs =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     const selectedDataDelete =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setSelectedDataDelete(selectedDataDelete);
  //     setselectedCustomerCheckbox(selectedCustomerCheckboxIDs);
  //     const datasplitforpath = selectedCustomerCheckboxIDs?.split(",");
  //     pathforpdf = datasplitforpath?.join("~");
  //     setselectedCustomerCheckpathforpdf(pathforpdf);
  //     console.log("Datasasasa", pathforpdf);

  //     // get emails of selectdids
  //     setSelectedRows(e.selectedRows.map((x) => x.Email));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Email);
  //     const selectedCustomerCheckboxEmails =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedCustomerCheckEmails(selectedCustomerCheckboxEmails);
  //     console.log(selectedCustomerCheckboxEmails);
  //   }
  // };

  // const handleDeletePopup = (pID) => {
  //   console.log(pID, "pid==>");
  //   const deleteRequestParam = {
  //     id: pID,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  //   // setShowDateFilterModal(true);
  //   // setShowAction(false);
  //   setDeleteModalOpen(true)
  // };

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;

    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.Id).join(",");
    } else {
      data = id;
    }

    const deleteRequestParam = {
      id: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  const handleCustomerEmails = (id, rows, field) => {
    let a = rows.map((el) => el.original.Email);
    console.log(a, "aaa");
    selectData[currentPage] = rows?.map((x) => x.original.Email);
    const selectedCustomerCheckboxEmails =
      selectData.length > 0 ? selectData[currentPage].toString() : "";
    setselectedCustomerCheckEmails(selectedCustomerCheckboxEmails);
  };

  console.log(selectedCustomerCheckEmails, "selectedCustomerCheckEmails");

  // const contextActions = useMemo(() => {
  //   // for handling barcode label
  //   const handlebarcode = (pID) => {
  //     const barcodeRequestParam = pID;

  //     localStorage.setItem(
  //       "BarcodeRequestParam",
  //       barcodeRequestParam
  //       // JSON.stringify(barcodeRequestParam)
  //     );
  //   };

  //   // For handle pdf
  //   const handlepdf = () => {
  //     console.log("Enyer", selectedCustomerCheckboxs);
  //     axios
  //       .get(
  //         `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${selectedCustomerCheckboxs}`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             Authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         const doc = new jsPDF();

  //         let position = 0;
  //         for (let i = 0; i < res.data.ResponseData.length; i++) {
  //           console.log(res.data.ResponseData.length);
  //           position = position + 10;
  //           doc.setFontSize(10);

  //           doc.text(
  //             `FirstName: ${res.data.ResponseData[i].FirstName}`,
  //             10,
  //             position
  //           );
  //           position = position + 10;
  //           doc.text(
  //             `LastName: ${res.data.ResponseData[i].LastName}`,
  //             10,
  //             position
  //           );
  //           position = position + 10;
  //           doc.text(`Email: ${res.data.ResponseData[i].Email}`, 10, position);
  //           position = position + 10;
  //           doc.text(`City: ${res.data.ResponseData[i].City}`, 10, position);
  //           position = position + 10;
  //           doc.text(
  //             `Address1: ${res.data.ResponseData[i].Address1}`,
  //             10,
  //             position
  //           );
  //           console.log(res.data.ResponseData);

  //           position = position + 10;

  //           if ((i + 1) % 4 == 0) {
  //             doc.addPage();
  //             position = 0;
  //           } else if (i == res.data.ResponseData.length - 1) {
  //           }
  //         }
  //         //   doc.deletePage(Last);
  //         doc.save(`Customers_mailing_label${Date.now()}.pdf`);
  //         setState({ data: res.data.ResponseData });
  //       });
  //   };

  //   return (
  //     <>
  //       <div className="row px-2 ">
  //         <div className="col-12 align-self-center">
  //           {checkUserPermission(PERMISSION_EMAIL_CUSTOMERS) ? (
  //             <a href={"mailto:" + selectedCustomerCheckEmails}>
  //               <button type="button" className="btn btn-dark btn-sm ">
  //                 <i className="fa fa-envelope fa-sm" /> E-mail
  //               </button>
  //             </a>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>

  //       <div className="row px-2">
  //         <div className="col-12 align-self-center">
  //           {/* <a href={"/mailing_labels/" + selectedCustomerCheckpathforpdf}> */}
  //           {checkUserPermission(PERMISSION_MAILING_LABELS) ? (
  //             <button
  //               type="button"
  //               className="btn btn-dark btn-sm"
  //               title="MailingLabels"
  //               onClick={handlepdf}
  //             >
  //               <i className="fa fa-envelope-square fa-sm" /> Mailing-Labels
  //             </button>
  //           ) : (
  //             ""
  //           )}
  //           {/* </a> */}
  //         </div>
  //       </div>

  //       <div className="row px-2 ">
  //         <div className="col-12 align-self-center">
  //           {checkUserPermission(PERMISSION_BARCODE_LABELS) ? (
  //             <a href={"/customer-barcode-label"}>
  //               <button
  //                 type="button"
  //                 className="btn btn-dark btn-sm"
  //                 onClick={handlebarcode(selectedCustomerCheckboxs)}
  //               >
  //                 <i className="fa fa-envelope-square fa-sm" /> Barcode Labels
  //               </button>
  //             </a>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>

  //       <div className="row px-2">
  //         <div className="col-12 align-self-center">
  //           {/* () => setLgShow(true) */}
  //           {checkUserPermission(PERMISSION_BARCODE_SHEETS) ? (
  //             <button
  //               type="button"
  //               className="btn btn-dark btn-sm"
  //               data-bs-toggle="modal"
  //               data-bs-target="#BarcodeSheetModal"
  //               title="MailingLabels"
  //               onClick={() => handlebarcodesheet(selectedCustomerCheckboxs)}
  //             >
  //               <i className="fa fa-envelope-square fa-sm" /> Barcode-Sheets
  //             </button>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>
  //       <div className="row px-2">
  //         {checkUserPermission(PERMISSION_DELETE) && (
  //           <button
  //             type="button"
  //             className="btn btn-danger btn-sm pull-left "
  //             data-bs-toggle="modal"
  //             data-bs-target="#DeleteConfirmationModal"
  //             onClick={() => handleDeletePopup()}
  //           >
  //             <i className="fa fa-trash fa-sm" /> Delete Selected
  //           </button>
  //         )}
  //       </div>
  //     </>
  //   );
  // }, [data, selectedRows, toggleCleared]);

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };

  const formatDate = (string) => {
    return moment(string).format("YYYY-DD-MM");
  };

  const handleSearchAccordingToDate = () => {
    handleListData(
      startingDate,
      endingDate,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };

  useEffect(() => {
    // console.log(quickBookOptions?.value,"value")
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    // else if (quickBookOptions?.value == 2) {
    //   setStartingDate(customStartingDate);
    //   setEndingDate(customEndingDate);
    // }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //currentmonth
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else if (quickBookOptions?.value == 2) {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);

  // console.log(startingDate,endingDate,"startandend")

  useEffect(
    () => {
      // if (quickBookOptions?.value !== 2) {
      handleListData(
        // 1,
        // perPageSize,
        // searchtext,
        // sortingId,
        // sortingDirection,
        startingDate,
        endingDate,
        columnFilters,
        globalFilter,
        pagination,
        sorting
      );
    },
    // }
    [quickBookOptions, columnFilters, globalFilter, pagination, sorting]
  );

  // Table Data
  // const columns = [
  //   // {
  //   //   name: "Sr.No",
  //   //   selector: (row, index) => index + 1,
  //   //   sortable: false,
  //   //   width: "80px",
  //   // },
  //   {
  //     name: "Action",
  //     cell: (row) => (

  //       <div class="btn-group-sm" role="group" >
  //         <Link className="btn btn-primary btn-sm btn-custom-padding"
  //           to={`/manage-customers/${row.Id}`}
  //           style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //         >
  //           Edit
  //         </Link>

  //         <button
  //           type="button"
  //           className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //           data-bs-toggle="dropdown"
  //           aria-haspopup="true"
  //           aria-expanded="false"
  //           style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //         >
  //         </button>
  //         <div className="dropdown-menu">
  //           {checkUserPermission(PERMISSION_EDIT) ? (
  //             <li>
  //               <Link className="dropdown-item me-3" to={`/manage-customers/${row.Id}`}>
  //                 <i className="fa fa-edit" title="Edit"></i>Edit
  //               </Link>
  //             </li>
  //           ) : (
  //             ""
  //           )}
  //           {checkUserPermission(PERMISSION_DELETE) ? (
  //             <li>
  //               <Link
  //                 className="dropdown-item confirm-text"
  //                 to="#"
  //                 title="Delete"
  //                 data-bs-toggle="modal"
  //                 data-bs-target="#DeleteConfirmationModal"
  //                 onClick={() => handleDeletePopup(row.Id)}
  //               >
  //                 <i
  //                   className="fa fa-trash"
  //                   data-bs-toggle="tooltip"
  //                   title="Delete"
  //                 ></i>
  //                 Delete
  //               </Link>
  //             </li>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //     //width: "7%",//"100px",
  //     minWidth: "90px",
  //     width: "90px",
  //   },
  //   {
  //     name: "Company Name",
  //     selector: "CompanyName",
  //     sortable: true,
  //     width: "170px",
  //     cell: (row) => (
  //       <>
  //         <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
  //           {row.CompanyName}
  //         </Link>
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Name",
  //     // selector: (row) => row.FirstName + " " + row.LastName,
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.FirstName + " " + row.LastName}>
  //         {row.FirstName + " " + row.LastName}
  //       </p>
  //     ),
  //     sortable: true,
  //     // cell: (row) => (
  //     //   <>
  //     //   <Link class="text-dark" to={`/manage-customers/${row.Id}`}>
  //     //     {row.FirstName} {" "} {row.LastName}
  //     //   </Link>
  //     //   </>
  //     // ),
  //     width: "130px",
  //   },
  //   {
  //     name: "E-Mail",
  //     // selector: "Email",
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.Email}>
  //         {row.Email}
  //       </p>
  //     ),
  //     sortable: true,
  //     width: "160px",
  //   },
  //   {
  //     name: "Phone Number",
  //     selector: "PhoneNumber",
  //     sortable: true,
  //     width: "150px",
  //   },
  //   // {
  //   //   name: "Profile",
  //   //   selector: "Image",
  //   //   sortable: true,
  //   //   cell: (row) => (
  //   //     <>
  //   //       <a href={row.Image} target="_blank"><img
  //   //         src={row.Image}
  //   //         alt="Profile Image"
  //   //         style={{
  //   //           maxWidth: "30px",
  //   //           maxHeight: "70px",
  //   //           margin: "5px",
  //   //         }}
  //   //         onError={(e) => {
  //   //           e.target.onerror = null;
  //   //            // style={{
  //   //         //   maxWidth: "70px",
  //   //         //   maxHeight: "70px",
  //   //         //   margin: "5px",
  //   //         // }}
  //   //           e.target.src = Noimage;
  //   //         }}
  //   //       ></img></a>
  //   //     </>
  //   //   ),
  //   // },
  //   // {
  //   //   name: "Created On",
  //   //   selector: (row) => formatDate(row.CreatedDate),
  //   //   sortable: true,
  //   //   width: "170px",
  //   // },
  //   {
  //     name: "Opening Balance",
  //     selector: (row) => parseFloat(row.Openingbalance).toFixed(2),
  //     sortable: true,
  //     width: "170px",
  //   },
  //   {
  //     name: "Account Balance",
  //     selector: (row) => parseFloat(row.Balance).toFixed(2),
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "Profile",
  //     selector: "Image",
  //     sortable: true,
  //     cell: (row) => (
  //       <>
  //         <a href={row.Image} target="_blank"><img
  //           src={row.Image}
  //           alt="Profile Image"
  //           style={{
  //             maxWidth: "30px",
  //             maxHeight: "70px",
  //             margin: "5px",
  //           }}
  //           onError={(e) => {
  //             e.target.onerror = null;
  //             e.target.src = Noimage;
  //           }}
  //         ></img></a>
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Created On",
  //     selector: (row) => formatDate(row.CreatedDate),
  //     sortable: true,
  //     width: "160px",
  //   },
  //   // {
  //   //   name: "Action",
  //   //   // width: "20%",
  //   //   cell: (row) => (
  //   //     <>
  //   //       {checkUserPermission(PERMISSION_EDIT) ? (
  //   //         <Link className="me-3" to={`/manage-customers/${row.Id}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : (
  //   //         ""
  //   //       )}
  //   //       {checkUserPermission(PERMISSION_DELETE) ? (
  //   //         <Link
  //   //           className="confirm-text"
  //   //           to="#"
  //   //           title="Delete"
  //   //           data-bs-toggle="modal"
  //   //           data-bs-target="#DeleteConfirmationModal"
  //   //           onClick={() => handleDeletePopup(row.Id)}
  //   //         >
  //   //           <i
  //   //             className="fa fa-trash text-red fa-2x"
  //   //             data-bs-toggle="tooltip"
  //   //             title="Delete"
  //   //           ></i>
  //   //         </Link>
  //   //       ) : (
  //   //         ""
  //   //       )}
  //   //     </>
  //   //   ),
  //   //   // ignoreRowClick: true,
  //   //   // allowOverflow: true,
  //   //   // button: true,
  //   // },
  // ];

  const columns = useMemo(() => [
    {
      //     //   cell: (row) => (

      //     //     <div class="btn-group-sm" role="group" >
      //     //       {checkUserPermission(PERMISSION_EDIT) && (
      //     //         <Link className="btn btn-primary btn-sm btn-custom-padding"
      //     //           to={`/manage-customers/${row.Id}`}
      //     //           style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
      //     //         >
      //     //           Edit
      //     //         </Link>
      //     //       )}
      //     //       {(checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE)) && (
      //     //         <>
      //     //           <button
      //     //             type="button"
      //     //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
      //     //             data-bs-toggle="dropdown"
      //     //             aria-haspopup="true"
      //     //             aria-expanded="false"
      //     //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
      //     //           >
      //     //           </button>
      //     //           <div className="dropdown-menu">
      //     //             {checkUserPermission(PERMISSION_EDIT) ? (
      //     //               <li>
      //     //                 <Link className="dropdown-item me-3" to={`/manage-customers/${row.Id}`}>
      //     //                   <i className="fa fa-edit" title="Edit"></i>Edit
      //     //                 </Link>
      //     //               </li>
      //     //             ) : (
      //     //               ""
      //     //             )}
      //     //             {checkUserPermission(PERMISSION_DELETE) ? (
      //     //               <li>
      //     //                 <Link
      //     //                   className="dropdown-item confirm-text"
      //     //                   to="#"
      //     //                   title="Delete"
      //     //                   data-bs-toggle="modal"
      //     //                   data-bs-target="#DeleteConfirmationModal"
      //     //                   onClick={() => handleDeletePopup(row.Id)}
      //     //                 >
      //     //                   <i
      //     //                     className="fa fa-trash"
      //     //                     data-bs-toggle="tooltip"
      //     //                     title="Delete"
      //     //                   ></i>
      //     //                   Delete
      //     //                 </Link>
      //     //               </li>
      //     //             ) : (
      //     //               ""
      //     //             )}
      //     //           </div>
      //     //         </>
      //     //       )}
      //     //     </div>
      //     //   ),
      //     //   ignoreRowClick: true,
      //     //   allowOverflow: true,
      //     //   button: true,
      //     //   //width: "7%",//"100px",
      //     //   minWidth: "90px",
      //     //   width: "90px",
      //     // },
      //     // {
      //     //   name: "Company Name",
      //     //   selector: "CompanyName",
      //     //   sortable: true,
      //     //   width: "170px",
      //     //   cell: (row) => (

      //     //     <>
      //     //       {checkUserPermission(PERMISSION_EDIT) ?
      //     //         <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
      //     //           {row.CompanyName}
      //     //         </Link>
      //     //         :
      //     //         row.CompanyName
      //     //       }
      //        header: "Company Name",
      //       accessorKey: "CompanyName",
      //       // enableGrouping: false, //do not let this column be grouped
      //     },
      //     {
      //       header: "Name",
      //       accessorKey: "Name",
      //       Cell: ({ row }) => (
      //         <>
      //           <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
      //             {row.original.FirstName} {row.original.LastName}
      //           </Link>
      //         </>
      //       ),

      //       // enableGrouping: false, //do not let this column be grouped
      //     },
      //     // {
      //     //   header: "DATE",
      //     //   accessorKey: "DATE",
      //     //   Cell: ({row})=> moment(row.original.DATE).format("YYYY-MM-DD")
      //     // },
      //     {
      //       header: "E-Mail",
      //       accessorKey: "Email",
      //       Cell: ({ row }) => (
      //         <>
      //           <p title={row.original.Email}>{row.original.Email}</p>
      //         </>
      //       ),
      // =======
      header: "Company Name",
      accessorKey: "CompanyName",
      Cell: ({ row }) => (
        <>
          <Link
            class="text-warning"
            to={`/manage-customers/${row.original.Id}`}
          >
            {row.original.CompanyName}
          </Link>
        </>
      ),
    },
    {
      header: "Name",
      accessorKey: "FirstName",
      Cell: ({ row }) => (
        <p
          className="word-break-data"
          title={row.original.FirstName + " " + row.original.LastName}
        >
          {row.original.FirstName + " " + row.original.LastName}
        </p>
      ),
    },
    {
      header: "E-Mail",
      accessorKey: "Email",
      Cell: ({ row }) => (
        <p className="word-break-data" title={row.original.Email}>
          {row.original.Email}
        </p>
      ),
    },
    {
      header: "Phone Number",
      accessorKey: "PhoneNumber",
    },
    {
      header: "Opening Balance",
      accessorKey: "Openingbalance",
      Cell: ({ row }) => parseFloat(row.original.Openingbalance).toFixed(2),
    },
    {
      header: "Account Balance",
      accessorKey: "Balance",
      Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
    },
    {
      header: "Profile",
      accessorKey: "Image",
      Cell: ({ row }) => (
        <>
          <a href={row.original.Image} target="_blank">
            <img
              src={row.original.Image}
              alt="Profile Image"
              style={{
                maxWidth: "30px",
                maxHeight: "70px",
                margin: "5px",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Noimage;
              }}
            ></img>
          </a>
        </>
      ),
    },
    {
      header: "Created On",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("DD-MM-YYYY HH:mm:ss"),
    },
  ]);
  // >>>>>>> Bhaskar_DataTableModificationFeedback_06-10-2023

  // enableGrouping: false, //do not let this column be grouped
  //   },

  //   {
  //     header: "Phone Number",
  //     accessorKey: "PhoneNumber",
  //   },
  //   {
  //     header: "Profile",
  //     accessorKey: "Image",
  //     Cell: ({ row }) => (
  //       <>
  //         <a href={row.original.Image} target="_blank">
  //           <img
  //             src={row.original.Image}
  //             alt="Profile Image"
  //             style={{
  //               maxWidth: "30px",
  //               maxHeight: "70px",
  //               margin: "5px",
  //             }}
  //             onError={(e) => {
  //               e.target.onerror = null;
  //               // style={{
  //               //   maxWidth: "70px",
  //               //   maxHeight: "70px",
  //               //   margin: "5px",
  //               // }}
  //               e.target.src = Noimage;
  //             }}
  //           ></img>
  //         </a>
  //       </>
  //     ),

  //     // enableGrouping: false, //do not let this column be grouped
  //   },

  //   {
  //     header: "Opening Balance",
  //     accessorKey: "OpeningBalance",
  //     Cell: ({ row }) => parseFloat(row.original.Openingbalance).toFixed(2),
  //   },

  //   {
  //     header: "Account Balance",
  //     accessorKey: "AccountBalance",
  //     Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
  //   },
  //   {
  //     header: "Created On",
  //     accessorKey: "CreatedOn",
  //     Cell: ({ row }) => formatDate(row.original.CreatedDate),
  //   },
  // ]);

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.customersBaseUrl}/customers/exportexcel`,
        {
          filtertext: searchtext,
          ordercolumn: sortingId,
          currentorder: sortingDirection,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);

        const data =
          res.data.ResponseData.length > 0 ? res.data.ResponseData : [];

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert the data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, `customers_details_.xlsx`);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // store checkbox checked values to hide or show columns
  // const handleExcelExport = () => {
  //   setLoading(true);
  //   axios({
  //     url: `${config.customersBaseUrl}/customers/exportexcel`,
  //     method: "POST",
  //     data: {
  //       filtertext: searchtext,
  //       ordercolumn: sortingId,
  //       currentorder: sortingDirection,
  //     },
  //     headers: {
  //       Authorization: token,
  //     },
  //     responseType: "blob", // set response type to blob
  //   })
  //     .then((res) => {
  //       const url = window.URL.createObjectURL(new Blob([res.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", "data.xlsx"); // set file name
  //       document.body.appendChild(link);
  //       link.click();
  //       toastSuccess(DATA_EXPORT);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       toastError(ERROR_MESSAGE);
  //       setLoading(false);
  //     });
  // };

  // function handleCheckboxChange(columnName) {
  //   if (hiddenColumns.includes(columnName)) {
  //     setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
  //   } else {
  //     setHiddenColumns([...hiddenColumns, columnName]);
  //   }
  // }

  // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  const handleChangeCustomStartingDate = (event) => {
    console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const handleQuickBookChange = (fieldName, event) => {
    // console.log("Value ==> ", event);
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      var currentDateForLastWeek = new Date();
      // console.log("currentDateForLastWeek ==> ", currentDateForLastWeek);
      // Set the date to the start of the current week (Sunday)
      var startOfWeekForLastWeek = new Date(
        currentDateForLastWeek.setDate(
          currentDateForLastWeek.getDate() - currentDateForLastWeek.getDay()
        )
      );
      // console.log("startOfWeekForLastWeek ==> ", startOfWeekForLastWeek);

      // Set the date to the end of the last week (Saturday)
      var endOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(startOfWeekForLastWeek.getDate() - 1)
      );
      // console.log("endOfLastWeekForLastWeek ==> ", endOfLastWeekForLastWeek);

      // Set the date to the start of the last week (Sunday)
      var startOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(endOfLastWeekForLastWeek.getDate() - 6)
      );

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForLastWeek = startOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      var endDateStringForLastWeek = endOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      // Output the results
      // console.log(
      //   "Last week started on " +
      //     startDateStringForLastWeek +
      //     " and ended on " +
      //     endDateStringForLastWeek
      // );
      setStartingDate(startDateStringForLastWeek);
      setEndingDate(endDateStringForLastWeek);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      var currentDateForCurrentWeek = new Date();
      // console.log("currentDateForCurrentWeek ==> ", currentDateForCurrentWeek);

      // Set the date to the start of the current week (Sunday)
      var startOfWeekForCurrentWeek = new Date(
        currentDateForCurrentWeek.getTime() -
          currentDateForCurrentWeek.getDay() * 24 * 60 * 60 * 1000
      );
      // console.log("startOfWeekForCurrentWeek ==> ", startOfWeekForCurrentWeek);

      // Set the date to the end of the current week (Saturday)
      var endOfWeekForCurrentWeek = new Date(
        startOfWeekForCurrentWeek.getTime() + 6 * 24 * 60 * 60 * 1000
      );
      // console.log("endOfWeekForCurrentWeek ==> ", endOfWeekForCurrentWeek);

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForCurrentWeek = startOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      var endDateStringForCurrentWeek = endOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   "Current week started on " +
      //     startDateStringForCurrentWeek +
      //     " and ended on " +
      //     endDateStringForCurrentWeek
      // );

      setStartingDate(startDateStringForCurrentWeek);
      setEndingDate(endDateStringForCurrentWeek);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      // Get today's date
      const todayForLastMonth = new Date();

      // Get the first day of the current month
      const firstDayCurrentMonthForLastMonth = new Date(
        todayForLastMonth.getFullYear(),
        todayForLastMonth.getMonth(),
        1
      );

      // Get the last day of the previous month
      const lastDayPrevMonthForLastMonth = new Date(
        firstDayCurrentMonthForLastMonth.getTime() - 1
      );

      // Get the starting date of the previous month
      const firstDayPrevMonthForLastMonth = new Date(
        lastDayPrevMonthForLastMonth.getFullYear(),
        lastDayPrevMonthForLastMonth.getMonth(),
        1
      );

      // Format the starting and ending dates of the previous month as yyyy-mm-dd
      const startDateFormattedForLastMonth = firstDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForLastMonth = lastDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of last month: ${startDateFormattedForLastMonth}`
      // );
      // console.log(`Ending date of last month: ${endDateFormattedForLastMonth}`);
      setStartingDate(startDateFormattedForLastMonth);
      setEndingDate(endDateFormattedForLastMonth);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      // Get today's date
      const todayForCurrentMonth = new Date();

      // Get the first day of the current month
      const firstDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth(),
        1
      );

      // Get the last day of the current month
      const lastDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth() + 1,
        0
      );

      // Format the starting and ending dates of the current month as yyyy-mm-dd
      const startDateFormattedForCurrentMonth = firstDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForCurrentMonth = lastDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of current month: ${startDateFormattedForCurrentMonth}`
      // );
      // console.log(
      //   `Ending date of current month: ${endDateFormattedForCurrentMonth}`
      // );
      setStartingDate(startDateFormattedForCurrentMonth);
      setEndingDate(endDateFormattedForCurrentMonth);
    } else if (event?.value == 7) {
      setStartingDate(moment().startOf("day").format("YYYY-MM-DD"));
      setEndingDate(moment().startOf("day").format("YYYY-MM-DD"));
    } else if (event?.value == 8) {
      const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
      setStartingDate(yesterday);
      setEndingDate(yesterday);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  const handlepdf = (rows) => {
    selectData[currentPage] = rows.map((x) => x.original.Id);
    const selectedCustomerCheckboxIDs =
      selectData.length > 0 ? selectData[currentPage].toString() : "";
    // console.log("Enyer", selectedCustomerCheckboxs);
    axios
      .get(
        `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${selectedCustomerCheckboxIDs}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const doc = new jsPDF();

        let position = 0;
        for (let i = 0; i < res.data.ResponseData.length; i++) {
          console.log(res.data.ResponseData.length);
          position = position + 10;
          doc.setFontSize(10);

          doc.text(
            `FirstName: ${res.data.ResponseData[i].FirstName}`,
            10,
            position
          );
          position = position + 10;
          doc.text(
            `LastName: ${res.data.ResponseData[i].LastName}`,
            10,
            position
          );
          position = position + 10;
          doc.text(`Email: ${res.data.ResponseData[i].Email}`, 10, position);
          position = position + 10;
          doc.text(`City: ${res.data.ResponseData[i].City}`, 10, position);
          position = position + 10;
          doc.text(
            `Address1: ${res.data.ResponseData[i].Address1}`,
            10,
            position
          );
          console.log(res.data.ResponseData);

          position = position + 10;

          if ((i + 1) % 4 == 0) {
            doc.addPage();
            position = 0;
          } else if (i == res.data.ResponseData.length - 1) {
          }
        }
        //   doc.deletePage(Last);
        doc.save(`Customers_mailing_label${Date.now()}.pdf`);
        setState({ data: res.data.ResponseData });
      });
  };

  const handlebarcode = (rows) => {
    selectData[currentPage] = rows.map((x) => x.original.Id);
    const selectedCustomerCheckboxIDs =
      selectData.length > 0 ? selectData[currentPage].toString() : "";

    const barcodeRequestParam = { id: selectedCustomerCheckboxIDs };
    //   Barcode_Id: pID,
    // };
    localStorage.setItem(
      "BarcodeRequestParam",
      // JSONbarcodeRequestParam
      JSON.stringify(barcodeRequestParam)
    );

    getCustomerDetailsForLabelById(barcodeRequestParam);
  };

  // const handlebarcodesheets=(rows)=>{
  //   selectData[currentPage] = rows.map((x) => x.original.Id);
  //   const selectedCustomerCheckboxIDs =
  //     selectData.length > 0 ? selectData[currentPage].toString() : "";

  //   const barcodeRequestParam = selectedCustomerCheckboxIDs;
  //   //   Barcode_Id: pID,
  //   // };
  //   localStorage.setItem(
  //     "BarcodeRequestParam",
  //     barcodeRequestParam
  //     // JSON.stringify(barcodeRequestParam)
  //   );

  //   getCustomerDetailsForLabelById(barcodeRequestParam);
  // };

  const handlebarcodesheets = (rows) => {
    selectData[currentPage] = rows.map((x) => x.original.Id);
    const selectedCustomerCheckboxIDs =
      selectData.length > 0 ? selectData[currentPage].toString() : "";

    const barcodeRequestParam = { id: selectedCustomerCheckboxIDs };
    //   Barcode_Id: pID,
    // };
    localStorage.setItem(
      "BarcodeRequestParam",
      // barcodeRequestParam
      JSON.stringify(barcodeRequestParam)
    );

    getCustomerDetailsForLabelById(barcodeRequestParam);
  };

  // const handleDelete = (id,rows, field) => {
  //   // console.log(id, rows.map((el)=>el.original),field, "id===>");

  //   const data=rows.map((el) => el.original.Id).join(",")
  //   // console.log(rows, field, "rows==>");
  //   const deleteRequestParam = {
  //     undeletecustomersids: data,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  //   setDeleteModalOpen(true)
  // };

  const handleQuickBookDownload = () => {
    if (
      startingDate === undefined ||
      (endingDate === undefined && quickBookOptions.value == 1)
    ) {
      setStartingDate("");
      setEndingDate("");
    } else if (
      startingDate === undefined ||
      (endingDate === undefined && quickBookOptions.value == 2)
    ) {
      // console.log("Undefined dates");
    } else {
      axios
        .get(
          `${
            config.customersBaseUrl
          }/customers/excelexportlisting?filtertext=${""}&startdate=${startingDate}&enddate=${endingDate}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // console.log("res ==> ", res.data.ResponseData);

          const data =
            res.data.ResponseData.length > 0
              ? res.data.ResponseData
              : [
                  {
                    [`Id`]: null,
                    [`Name`]: null,
                    [`Company Name`]: null,
                    [`City`]: null,
                    [`Country`]: null,
                    [`Created Date`]: null,
                    [`Customer Type`]: null,
                    [`Email`]: null,
                    [`Fax`]: null,
                    [`Mobile Number`]: null,
                    [`Opening Balance`]: null,
                    [`State`]: null,
                    [`Street`]: null,
                    [`Website`]: null,
                    [`Zip`]: null,
                    [`Phone Number`]: null,
                    [`ReSale Number`]: null,
                  },
                ];

          // Create a new workbook
          const workbook = XLSX.utils.book_new();

          // Convert the data to a worksheet
          const worksheet = XLSX.utils.json_to_sheet(data);

          // Add the worksheet to the workbook
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          // Save the workbook as an Excel file
          XLSX.writeFile(
            workbook,
            `customer_quickbook_${startingDate}_${endingDate}.xlsx`
          );
          setLoading(false);
        })
        .catch((err) => {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        });
    }
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content   container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              {/* <div className="col"> */}
              <h3 className="page-title">Customers</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Customers List</li>
              </ul>
              {/* </div> */}
            </div>
          </div>

          <div className="d-flex" style={{ width: "100%" }}>
            <div className="d-flex mb-2" style={{ width: "100%" }}>
              {/* <div
                className="p-1 col-lg-2 col-md-6 col-sm-12 mt-3
                   "
              >
                <input
                  type="search"
                  placeholder="Search..."
                  className="search-btn form-control form-control-sm w-100 pull-right"
                  onChange={ChangeFilterText}
                  value={searchtext}
                />
              </div> */}
              <div className="p-1 col-md-3 mt-3">
                <Select
                  defaultValue={quickBookOptions}
                  onChange={(event) => {
                    handleQuickBookChange("ExcelExport", event);
                  }}
                  options={options}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  // hideSelectedOptions={true}
                  styles={selectStyles}
                  id="ExcelExport"
                  name="ExcelExport"
                  className="custom-search-select"
                />
              </div>
              {quickBookOptions?.value == 2 && (
                <>
                  <div className="col-lg-2 col-md-6 col-sm-12 ml-2">
                    Custom Start Date:
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                      onChange={(event) =>
                        handleChangeCustomStartingDate(event)
                      }
                    />
                  </div>
                  <div className="col-lg-2 col-md-6 col-sm-12 ml-2">
                    Custom End Date:
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="EndDate"
                      name="EndDate"
                      onChange={(event) => handleChangeCustomEndingDate(event)}
                    />
                  </div>
                  <div className="p-1 col-lg-1 col-md-6 col-sm-12 mt-3 ml-2">
                    <button
                      className="btn btn-dark btn-sm"
                      onClick={() => handleSearchAccordingToDate()}
                    >
                      Search
                    </button>
                  </div>
                </>
              )}
              <div className="p-1 col-lg-3 col-md-6 col-sm-12 mt-3 ml-2">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => handleQuickBookDownload()}
                  title="Export to excel for quickbook"
                >
                  Export
                </button>
              </div>
            </div>
            <div className="d-flex">
              <div style={{ marginTop: "19px" }}>
                {checkUserPermission(PERMISSION_ADD) ? (
                  <Link
                    to="/manage-customers"
                    // className="btn btn-added pull-right"
                    className="btn btn-primary btn-sm pull-right"
                    style={{ width: "max-content" }}
                  >
                    <i className="fa fa-plus me-2 lg"></i>
                    New Customer
                  </Link>
                ) : (
                  ""
                )}
              </div>
              <div
                className="btn-group-sm pull-right ms-2"
                style={{ marginTop: "19px" }}
              >
                <button type="button" className="btn btn-outline-dark d-none">
                  More
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary dropdown-toggle me-1"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  More &nbsp;
                </button>
                <div className="dropdown-menu">
                  <li>
                    {checkUserPermission(PERMISSION_CUSTOMER_INTAKE_FORM) ? (
                      <Link class="dropdown-item" to="/customer-intake-form">
                        Customer Intake Form
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_IMPORT) ? (
                      <Link class="dropdown-item" to="/import-excel-customers">
                        Excel Import
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_EXPORT) ? (
                      <Link class="dropdown-item" onClick={handleExcelExport}>
                        Excel Export
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(
                      PERMISSION_MANAGE_DELETED_CUSTOMERS
                    ) ? (
                      <Link class="dropdown-item" to="/deleted-customers">
                        Manage Deleted Customers
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_CLEANUP_OLD_CUSTOMERS) ? (
                      <Link
                        to="#"
                        title="Cleanup old Customers"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#CleanupConfirmationModal"
                      >
                        Cleanup old Customers
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(
                      PERMISSION_CUSTOM_FIELD_CONFIGURATION
                    ) ? (
                      <Link
                        to="/custom-field-configuration"
                        title="Custom Field Configuration"
                        className="dropdown-item"
                      >
                        Customer Custom Fields
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                </div>
              </div>
              {/* <div className="btn-group-sm pull-right ms-2 dropdown" style={{ marginTop: "19px", marginRight: "21px" }}>
                <button
                  type="button"
                  className="btn btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button> */}
              {/* <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } 
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </div> */}
            </div>
          </div>

          <MaterialReactTable
            columns={columns}
            data={data}
            // positionPagination='top'
            enableColumnResizing
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            enableRowActions
            // enableEditing

            renderRowActionMenuItems={({ row }) => [
              // checkUserPermission(PERMISSION_EDIT) ? (
              <MenuItem
                key="edit"
                data-bs-toggle="modal"
                data-bs-target="#ChangePasswordModal"
                onClick={() => {
                  setPasswordModalOpen(true);
                  setCustomerId(row.original.Id);
                }}
              >
                change password
              </MenuItem>,
              // ) : (
              //   ""
              // ),
              checkUserPermission(PERMISSION_EDIT) ? (
                <MenuItem
                  key="edit"
                  onClick={() =>
                    navigate(`/manage-customers/${row.original.Id}`)
                  }
                >
                  Edit
                </MenuItem>
              ) : (
                ""
              ),
              checkUserPermission(PERMISSION_DELETE) ? (
                <MenuItem
                  className="confirm-text"
                  to="#"
                  // key="delete"

                  title="Delete"
                  data-bs-toggle="modal"
                  data-bs-target="#DeleteConfirmationModal"
                  onClick={() =>
                    handleDeletePopup(row.original.Id, "", "singlerowdelete")
                  }
                >
                  Delete
                </MenuItem>
              ) : (
                ""
              ),
            ]}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                {console.log(table, "tables")}

                {checkUserPermission(PERMISSION_EMAIL_CUSTOMERS) ? (
                  !table.getIsSomeRowsSelected() &&
                  !table.getIsAllRowsSelected() ? (
                    <Button
                      size="small"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      // data-bs-toggle="modal"
                      // data-bs-target="#UnDeleteConfirmationModal"
                      onClick={() =>
                        handleCustomerEmails(
                          "",
                          table.getSelectedRowModel().rows,
                          "multipleRowInactive"
                        )
                      }
                      startIcon={<EmailIcon />}
                      variant="contained"
                    >
                      E-mail
                    </Button>
                  ) : (
                    <a href={"mailto:" + selectedCustomerCheckEmails}>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        // data-bs-toggle="modal"
                        // data-bs-target="#UnDeleteConfirmationModal"
                        onClick={() =>
                          handleCustomerEmails(
                            "",
                            table.getSelectedRowModel().rows,
                            "multipleRowInactive"
                          )
                        }
                        startIcon={<EmailIcon />}
                        variant="contained"
                      >
                        E-mail
                      </Button>
                    </a>
                  )
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_MAILING_LABELS) ? (
                  <Button
                    size="small"
                    disabled={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    // data-bs-toggle="modal"
                    // data-bs-target="#UnDeleteConfirmationModal"
                    onClick={() => handlepdf(table.getSelectedRowModel().rows)}
                    startIcon={<EmailIcon />}
                    variant="contained"
                  >
                    Mailing-Labels
                  </Button>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_BARCODE_LABELS) ? (
                  !table.getIsSomeRowsSelected() &&
                  !table.getIsAllRowsSelected() ? (
                    <Button
                      size="small"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      // data-bs-toggle="modal"
                      // data-bs-target="#UnDeleteConfirmationModal"
                      onClick={() =>
                        handlebarcode(table.getSelectedRowModel().rows)
                      }
                      startIcon={<MailOutlineIcon />}
                      variant="contained"
                    >
                      Barcode Labels
                    </Button>
                  ) : (
                    <a href={"/customer-barcode-label"}>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        // data-bs-toggle="modal"
                        // data-bs-target="#UnDeleteConfirmationModal"
                        onClick={() =>
                          handlebarcode(table.getSelectedRowModel().rows)
                        }
                        startIcon={<MailOutlineIcon />}
                        variant="contained"
                      >
                        Barcode Labels
                      </Button>
                    </a>
                  )
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_BARCODE_SHEETS) ? (
                  // <a href={"/customer-barcode-label"}>
                  <Button
                    size="small"
                    disabled={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    data-bs-toggle="modal"
                    data-bs-target="#BarcodeSheetModal"
                    title="MailingLabels"
                    onClick={() =>
                      handlebarcodesheets(table.getSelectedRowModel().rows)
                    }
                    startIcon={<MailOutlineIcon />}
                    variant="contained"
                  >
                    Barcode-Sheets
                  </Button>
                ) : (
                  // </a>
                  ""
                )}

                {checkUserPermission(PERMISSION_DELETE) ? (
                  <Button
                    size="small"
                    disabled={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                    }
                    onClick={() =>
                      handleDeletePopup(
                        "",
                        table.getSelectedRowModel().rows,
                        "multipleRowInactive"
                      )
                    }
                    startIcon={<DeleteIcon />}
                    variant="contained"
                  >
                    Delete Selected
                  </Button>
                ) : (
                  ""
                )}

                {/* <Button
                  size="small"
                  onClick={() =>
                    // setPagination({ ...pagination, pageSize: totalRows })
                    setPagination({
                      ...pagination,
                      pageIndex: 0,
                      pageSize: totalRows,
                    })
                  }
                  variant="contained"
                >
                  Get All Data
                </Button> */}
              </Box>
            )}
            rowVirtualizerProps={{
              overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
              estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
            }}
            muiTableContainerProps={{
              sx: { maxHeight: "fit-content" },
            }}
            initialState={{
              density: "compact",
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 10 },
              // sorting: { id: "Name", desc: false }, //sort by state by default
            }}
            muiTablePaginationProps={{
              rowsPerPageOptions: [10, 25, 50, 100, 300],
            }}
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Error loading data",
                  }
                : undefined
            }
            // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            // enableColumnVirtualization={false}
            // enableColumnVirtualization
            state={{
              // columnFilters, // for termp comment filteron column
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        </div>
      </div>
      {/* </div >
            </div >
          </div > */}
      {/* <MaterialReactTable
        columns={columns}
        data={data}
        enableColumnResizing
        enableRowActions
        renderRowActionMenuItems={({ row }) =>
          [
            (checkUserPermission(PERMISSION_EDIT)) ?
              (<MenuItem key="edit" onClick={() => navigate(`/manage-customers/${row.original.Id}`)}>
                Edit
              </MenuItem>) : "",
            <MenuItem
              className="confirm-text"
              to="#"
              // key="delete"
              title="Delete"
              // data-bs-toggle="modal"
              // data-bs-target="#DeleteConfirmationModal"
              onClick={() => handleDeletePopup(row.original.Id)}
            >
              Delete
            </MenuItem>,
          ]
        }

        enableGrouping
        enableStickyHeader
        enableStickyFooter
        enableRowSelection
        enableColumnOrdering
        initialState={{
          density: "compact",
          expanded: true, //expand all groups by default
          // grouping: [""], //an array of columns to group by by default (can be multiple)
          pagination: { pageIndex: 0, pageSize: 25 },
          sorting: [{ id: "state", desc: false }], //sort by state by default
        }}
        // muiToolbarAlertBannerChipProps={{ color: "primary" }}
        // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
        muiTablePaginationProps={{
          rowsPerPageOptions: [25, 50, 100, 300, 500],
        }}
        muiTableContainerProps={{ sx: { maxHeight: 'fit-content' } }}
        // manualFiltering
        manualPagination
        manualSorting
        muiToolbarAlertBannerProps={
          isError
            ? {
              color: 'error',
              children: 'Error loading data',
            }
            : undefined
        }
        // onColumnFiltersChange={setColumnFilters}
        onGlobalFilterChange={setGlobalFilter}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        rowCount={totalRows}
        state={{
          // columnFilters,
          globalFilter,
          isLoading,
          pagination,
          showAlertBanner: isError,
          showProgressBars: isRefetching,
          sorting,
        }}
      /> */}
      {/* </div >
      </div > */}
      {/* </div> */}

      {/* change password */}
      <ChangePassword
        fieldId={customerId}
        open={PasswordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        field="Customer"
      />

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.customersBaseUrl}/customers/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />

      {/* {/* Cleanup old customer */}
      <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.customersBaseUrl}/customers/cleanupcustomer`}
      />

      <SkipbarcodeConfirmationModal
      // CleanupConformationApiUrl={`${config.customersBaseUrl}/customers/cleanupcustomer`}
      // onClick={handlebarcodesheet(selectedCustomerCheckboxs)}
      // onClick={window.location.reload()}
      />
    </>
  );
};

export default Customers;
